export const CREATE_ROW = 'Add'
export const UPDATE_ROW = 'Update'
export const DELETE_ROW = 'Delete'

export const FIELDS_TABLE = 'fieldsTable'
export const PERMISSION_TABLE = 'permissionTable'

export const scenarioFields = [
  'username',
  'type',
  'summary',
  'creationDateTime',
  'startDateTime',
  'endDateTime',
  'masterdataName',
  'parentName',
  'consolidated'
]

export const permList = [
  'read',
  'create',
  'delete',
  'update',
  'import_',
  'export'
]

export const defaultAddFormState = {
  role: '',
  fields: [],
  blocks: {}
}

export const defaultBlock = {
  scenarioTypes: [],
  minePermissions: [],
  otherPermissions: []
}

export const blockPrefix = 'block-'
